import { Helmet } from 'react-helmet';
import {
    Box,
    Button,
    Card,
    Radio,
    Collapse,
    Checkbox,
    Autocomplete,
    Container,
    Divider,
    Grid,
    Typography,
    Paper,
    TextField,
    Switch,
    FormGroup,
    FormControlLabel,
    MenuItem,
    Select,
    FormHelperText
} from '@mui/material';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect } from "react";
import { Link as RouterLink, useNavigate, useParams } from "react-router-dom";
import { makeStyles, styled } from "@mui/styles";
import emtyData from "../../../../assets/images/emty-data.png";
import { Formik } from "formik";
import * as Yup from 'yup';
import DialogIcon from "../../../../components/kpi/DialogIcon";
import { useFormik } from 'formik';
import * as yup from 'yup';
import * as Util from "../../../../services/global.service";
import { ReactComponent as ShowLess } from "../../../../assets/icons/showLess.svg";
import { ReactComponent as ShowMore } from "../../../../assets/icons/showMore.svg";
import Icon from '@mui/material/Icon';
import SimpleDialog from "../../../../components/SimpleDialog";
import ConfirmDialog from "../../../../components/ConfirmDialog";
import MessageDialog from "../../../../components/inbox/MessageDialog";
import adminService from "../../../../services/admin.service";
import ClickAwayListener from '@mui/material/ClickAwayListener';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import securityService from "../../../../services/security.service";

const styles = {
    path: {
        color: "#68717A",
    },
    icon: {
        color: "#6B6B6B",
        marginBottom: "-3px",
        marginRight: "10px",
    },
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
    buttonFile: {
        position: "absolute",
        right: "1px",
        top: "1px",
        // bottom: "9px",
        background: "linear-gradient(0deg, #E5E9EC, #E5E9EC), #404349",
        borderLeft: "1px solid #CED4DA",
        "border-radius": "0px 4px 4px 0px",
        width: "100px",
        color: "#404349",
        fontSize: "16px",
        // lineHeight: "23.92px",
        fontWeight: "300"
    },
    dropdowm: {
        position: "absolute",
        right: "20px",
        top: "40%",
        // bottom: "9px",
        color: "#404349",
        fontSize: "16px",
        // lineHeight: "23.92px",
        fontWeight: "300"
    },
};
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
const CreateRolePermission = (props) => {
    const { t } = useTranslation();
    const useStyles = makeStyles({
        iconContainer: {
            '& svg': {
                width: "45px",
                height: "45px"
            }
        },
        formTextField: {
            '& .MuiTextField-root': { m: 1, width: '25ch' },
        },
        input: {
            ".MuiFormHelperText-root": {
                color: " #CC6058 !important",
                fontSize: "14px",
                lineHeight: "15.4px",
            },
            ".MuiOutlinedInput-root": {
                padding: "8.5px 14px",
                ".MuiInputBase-input": {
                    padding: "0"
                }
            }
        },
        styleTag: {
            '& div > .MuiOutlinedInput-root': {
                '& .MuiChip-root': {
                    backgroundColor: "#5DA196",
                    color: "#ffffff",
                    borderRadius: "3px",
                    '& .MuiChip-deleteIcon': {
                        color: "#ffffff",
                    }
                },
            },
        }
    })
    const navigate = useNavigate();
    const clickLink = (data) => {
        navigate(data, { replace: false });
    }
    const classes = useStyles();
    const [status, setStatus] = React.useState(true);
    const [roleType, setRoleType] = React.useState("manual");
    const [errorText, seterrorText] = React.useState("");
    const [validateTarget, setValidateTarget] = React.useState("");
    const [checkCode, setCheckCode] = React.useState(false);
    const handleStatus = () => {
        setStatus(!status)
    }
    const [permissionGroup, setPermissionGroup] = React.useState([]);
    const [targetGroup, setTargetGroup] = React.useState([]);
    const [dataPermissionGroup, setValuePermissionGroup] = React.useState([]);
    const [showMoreTable, setShowMoreTable] = React.useState({});
    const [valueManagePermission, setValueManagePermission] = React.useState({});
    const [dataManagePermission, setManagePermission] = React.useState([]);

    const IOSSwitch = styled((props) => (
        <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
    ))(({ theme }) => ({
        width: "50px !important",
        height: "24px !important",
        padding: "0 !important",
        marginRight: "10px",
        '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: "4px 6px",
            transitionDuration: '300ms',
            '&.Mui-checked': {
                transform: 'translateX(22px)',
                color: '#fff',
                '& + .MuiSwitch-track': {
                    backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#5DA196',
                    opacity: 1,
                    border: 0,
                },
                '&.Mui-disabled + .MuiSwitch-track': {
                    opacity: 1,
                },
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
                color: '#33cf4d',
                border: '6px solid #fff',
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
                color:
                    theme.palette.mode === 'light'
                        ? theme.palette.grey[100]
                        : theme.palette.grey[600],
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 1,
            },
        },
        '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 16,
            height: 16,
        },
        '& .MuiSwitch-track': {
            borderRadius: 26 / 2,
            backgroundColor: theme.palette.mode === 'light' ? '#C0C0C0' : '#39393D',
            opacity: 1,
            transition: theme.transitions.create(['background-color'], {
                duration: 500,
            }),
        },
    }));
    const validationSchema = yup.object({
        code: yup.string().required(t('admin.inputForm.msgError.code')),
        permission_group: yup.string().required(t('admin.inputForm.msgError.code')),
        name: yup.string().max(80, "ความยาวไม่เกิน 80 ตัวอักษร").required(t('admin.inputForm.msgError.nameTH')),
        description: yup.string().max(180, "ความยาวไม่เกิน 180 ตัวอักษร"),
    });

    const validationSchemaAuto = yup.object({
        code: yup.string().required(t('admin.inputForm.msgError.code')),
        permission_group: yup.string().required(t('admin.inputForm.msgError.code')),
        name: yup.string().max(80, "ความยาวไม่เกิน 80 ตัวอักษร").required(t('admin.inputForm.msgError.nameTH')),
        description: yup.string().max(180, "ความยาวไม่เกิน 180 ตัวอักษร"),
        auto_target_group: yup.string().required(t('admin.inputForm.msgError.code')),
    });

    const validationSchemaTarget = yup.object({
        code: yup.string().required(t('admin.inputForm.msgError.code')),
        permission_group: yup.string().required(t('admin.inputForm.msgError.code')),
        name: yup.string().max(80, "ความยาวไม่เกิน 80 ตัวอักษร").required(t('admin.inputForm.msgError.nameTH')),
        description: yup.string().max(180, "ความยาวไม่เกิน 180 ตัวอักษร"),
        target_group: yup.string().required(t('admin.inputForm.msgError.code')),
    });

    const validationSchemaAll = yup.object({
        code: yup.string().required(t('admin.inputForm.msgError.code')),
        permission_group: yup.string().required(t('admin.inputForm.msgError.code')),
        name: yup.string().max(80, "ความยาวไม่เกิน 80 ตัวอักษร").required(t('admin.inputForm.msgError.nameTH')),
        description: yup.string().max(180, "ความยาวไม่เกิน 180 ตัวอักษร"),
        target_group: yup.string().required(t('admin.inputForm.msgError.code')),
        auto_target_group: yup.string().required(t('admin.inputForm.msgError.code')),
    });
    const formik = useFormik({
        initialValues: {
            code: '',
            name: '',
            description: '',
            permission_group: '',
            target_group: "",
            auto_target_group: "",
        },
        enableReinitialize: true,
        validationSchema: roleType === "auto" && permissionGroup.filter(rs => rs?.serial === validateTarget).length > 0 && permissionGroup.filter(rs => rs?.serial === validateTarget)[0].code === "target_group" ?
            validationSchemaAll
            :
            roleType === "auto" ?
                validationSchemaAuto
                :
                permissionGroup.filter(rs => rs?.serial === validateTarget).length > 0 && permissionGroup.filter(rs => rs?.serial === validateTarget)[0].code === "target_group" ?
                    validationSchemaTarget
                    :
                    validationSchema
        ,
        onSubmit: (values) => {
            adminService.checkCode("permission_role", values.code).then(
                (response) => {
                    setCheckCode(response?.data?.is_exist)
                    if (response?.data?.is_exist === false) {
                        submit(values)
                    }
                },
            ).catch(() => {
            })
        },
    });

    useEffect(() => {
        securityService.getRoleForm().then(
            (response) => {
                setPermissionGroup(Util.formatData(response?.data?.permission_group, []))
                setManagePermission(Util.formatData(response?.data?.form, []))
            },
        ).catch(() => {
        })
        securityService.listTargetGroup().then(
            (response) => {
                setTargetGroup(Util.formatData(response?.data?.target_group, []))
            },
        ).catch(() => {
        })
    }, []);

    useEffect(() => {
        if (dataManagePermission.length > 0) {
            let dt = {}
            let show = {}
            for (let index = 0; index <= dataManagePermission.length - 1; index++) {
                dt = { ...dt, [dataManagePermission[index]?.serial]: {} }
                show = { ...show, [dataManagePermission[index]?.serial]: false }
                if (Util.formatData(dataManagePermission[index]?.permissions, false) !== false) {
                    for (let id = 0; id <= dataManagePermission[index]?.permissions.length - 1; id++) {
                        dt[dataManagePermission[index]?.serial] = { ...dt[dataManagePermission[index]?.serial], [dataManagePermission[index]?.permissions[id]?.serial]: {} }
                        // if (dataManagePermission[index]?.permissions[id]?.enable?.have === true) {
                        //     dt[dataManagePermission[index]?.serial][dataManagePermission[index]?.permissions[id]?.serial].enable = dataManagePermission[index]?.permissions[id]?.enable?.value
                        // }
                        if (dataManagePermission[index]?.permissions[id]?.create?.have === true) {
                            dt[dataManagePermission[index]?.serial][dataManagePermission[index]?.permissions[id]?.serial].create = dataManagePermission[index]?.permissions[id]?.create?.value
                        }
                        if (dataManagePermission[index]?.permissions[id]?.edit?.have === true) {
                            dt[dataManagePermission[index]?.serial][dataManagePermission[index]?.permissions[id]?.serial].edit = dataManagePermission[index]?.permissions[id]?.edit?.value
                        }
                        if (dataManagePermission[index]?.permissions[id]?.delete?.have === true) {
                            dt[dataManagePermission[index]?.serial][dataManagePermission[index]?.permissions[id]?.serial].delete = dataManagePermission[index]?.permissions[id]?.delete?.value
                        }
                        if (dataManagePermission[index]?.permissions[id]?.import?.have === true) {
                            dt[dataManagePermission[index]?.serial][dataManagePermission[index]?.permissions[id]?.serial].import = dataManagePermission[index]?.permissions[id]?.import?.value
                        }
                        if (dataManagePermission[index]?.permissions[id]?.export?.have === true) {
                            dt[dataManagePermission[index]?.serial][dataManagePermission[index]?.permissions[id]?.serial].export = dataManagePermission[index]?.permissions[id]?.export?.value
                        }
                        if (dataManagePermission[index]?.permissions[id]?.view?.have === true) {
                            dt[dataManagePermission[index]?.serial][dataManagePermission[index]?.permissions[id]?.serial].view = dataManagePermission[index]?.permissions[id]?.view?.value
                        }
                    }
                }
            }
            setShowMoreTable(show)
            setValueManagePermission(dt);
        }
    }, [dataManagePermission]);


    useEffect(() => {
        if (checkCode === true) {
            setCheckCode(false)
        }
    }, [formik.values.code]);

    const handleCancel = () => {
        setDiscardDialog(true)
    }
    const [openFailedMessageDialog, setFailedMessageDialog] = React.useState(false);
    const handleOpenFailedMessageDialog = (value) => {
        setFailedMessageDialog(true);
    };
    const handleCloseFailedMessageDialog = (value) => {
        setFailedMessageDialog(false);
    };
    const [discardDialog, setDiscardDialog] = React.useState(false);
    const handleDiscardDialog = (value) => {
        setDiscardDialog(value)
    };
    const handleDiscardChangeConfirm = () => {
        handleDiscardDialog(false)
        clickLink('/admin/security')
    };
    const [isSuccessAddDialogOpen, openSuccessAddDialog] = React.useState(false);
    const handleDirect = () => {
        openSuccessAddDialog(false)
        navigate('/admin/security', { replace: false });
    }
    const submit = (data) => {
        let dt = {
            code: data?.code,
            name: data?.name,
            description: data?.description,
            status: status === true ? "active" : "inactive",
            role_type: roleType,
            permission_group: data?.permission_group,
            options: {
                target_group: Util.formatData(data?.target_group, ""),
                auto_target_group: Util.formatData(data?.auto_target_group, "")
            },
            features: dataManagePermission
        }
        for (let index = 0; index <= dt?.features.length - 1; index++) {
            for (let id = 0; id <= dt?.features[index].permissions.length - 1; id++) {
                let oldData = dt?.features[index].permissions[id]
                let newData = valueManagePermission[dt?.features[index].serial][dt?.features[index].permissions[id].serial]
                // if (oldData?.enable?.have === true) {
                //     dt.features[index].permissions[id].enable.value = newData?.enable
                // }
                if (oldData?.create?.have === true) {
                    dt.features[index].permissions[id].create.value = newData?.create
                }
                if (oldData?.edit?.have === true) {
                    dt.features[index].permissions[id].edit.value = newData?.edit
                }
                if (oldData?.delete?.have === true) {
                    dt.features[index].permissions[id].delete.value = newData?.delete
                }
                if (oldData?.import?.have === true) {
                    dt.features[index].permissions[id].import.value = newData?.import
                }
                if (oldData?.export?.have === true) {
                    dt.features[index].permissions[id].export.value = newData?.export
                }
                if (oldData?.view?.have === true) {
                    dt.features[index].permissions[id].view.value = newData?.view
                }
            }
        }
        securityService.addRolePermission(dt).then(
            (response) => {
                openSuccessAddDialog(true)
            },
        ).catch(() => {
            seterrorText(t(`security.createdFail`))
            handleOpenFailedMessageDialog(true)
        })
    }
    useEffect(() => {
        if (!formik.isSubmitting) return;
        if (Object.keys(formik.errors).length > 0) {
            document.getElementsByName(Object.keys(formik.errors)[0])[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }, [formik]);
    const showCheckBox = (data, type) => {
        let findData = data.permissions.filter((rs) => rs[type]?.have === true)
        if (findData.length > 0) {
            return true
        } else {
            return false
        }
    }

    const checkAll = (data, type) => {
        let oldData = JSON.parse(JSON.stringify(valueManagePermission))
        let sumFalse = 0
        let showTrue = JSON.parse(JSON.stringify(valueManagePermission))
        let showFalse = JSON.parse(JSON.stringify(valueManagePermission))
        for (let index = 0; index <= Object.keys(oldData[data]).length - 1; index++) {
            if (type === "all") {
                for (let id = 0; id <= Object.keys(oldData[data][Object.keys(oldData[data])[index]]).length - 1; id++) {
                    if (oldData[data][Object.keys(oldData[data])[index]][Object.keys(oldData[data][Object.keys(oldData[data])[index]])[id]] === false) {
                        sumFalse++
                    }
                    showTrue[data][Object.keys(oldData[data])[index]][Object.keys(oldData[data][Object.keys(oldData[data])[index]])[id]] = true
                    showFalse[data][Object.keys(oldData[data])[index]][Object.keys(oldData[data][Object.keys(oldData[data])[index]])[id]] = false
                }
            } else {
                if (oldData[data][Object.keys(oldData[data])[index]][type] === false) {
                    sumFalse++
                }
                showTrue[data][Object.keys(oldData[data])[index]][type] = true
                showFalse[data][Object.keys(oldData[data])[index]][type] = false
            }
        }
        if (sumFalse === 0 && type === "all") {
            setValueManagePermission(showFalse)
        } else if (type === "all") {
            setValueManagePermission(showTrue)
        } else {
            if (sumFalse === 0) {
                setValueManagePermission(showFalse)
            } else {
                setValueManagePermission(showTrue)
            }
        }
    }

    const checkOne = (data, subData, type) => {
        let oldData = JSON.parse(JSON.stringify(valueManagePermission))
        oldData[data][subData][type] = !oldData[data][subData][type]
        setValueManagePermission(oldData)
    }

    const changeShowMoreTable = (data) => {
        let oldData = JSON.parse(JSON.stringify(showMoreTable))
        oldData[data] = !oldData[data]
        setShowMoreTable(oldData)
    }
    const expandAll = () => {
        let oldData = JSON.parse(JSON.stringify(showMoreTable))
        let showTrue = {}
        let showFalse = {}
        let sumTrue = 0
        for (let index = 0; index <= Object.keys(oldData).length - 1; index++) {
            showFalse = { ...showFalse, [dataManagePermission[index]?.serial]: false }
            showTrue = { ...showTrue, [dataManagePermission[index]?.serial]: true }
            if (oldData[Object.keys(oldData)[index]] === true) {
                sumTrue++
            }
        }
        if (Object.keys(oldData).length === sumTrue) {
            setShowMoreTable(showFalse)
        } else {
            setShowMoreTable(showTrue)
        }
    }

    const showExpandAll = () => {
        let oldData = JSON.parse(JSON.stringify(showMoreTable))
        let sumTrue = 0
        for (let index = 0; index <= Object.keys(oldData).length - 1; index++) {
            if (oldData[Object.keys(oldData)[index]] === true) {
                sumTrue++
            }
        }
        if (Object.keys(oldData).length === sumTrue) {
            return true;
        } else {
            return false;
        }
    }

    const showCheckAll = (data, type) => {
        let oldData = JSON.parse(JSON.stringify(valueManagePermission))
        let sumFalse = 0
        if (Object.keys(oldData).length > 0) {
            for (let index = 0; index <= Object.keys(oldData[data]).length - 1; index++) {
                if (type === "all") {
                    for (let id = 0; id <= Object.keys(oldData[data][Object.keys(oldData[data])[index]]).length - 1; id++) {
                        if (oldData[data][Object.keys(oldData[data])[index]][Object.keys(oldData[data][Object.keys(oldData[data])[index]])[id]] === false) {
                            sumFalse++
                        }
                    }
                } else {
                    if (oldData[data][Object.keys(oldData[data])[index]][type] === false) {
                        sumFalse++
                    }
                }
            }
            if (sumFalse === 0) {
                return true;
            } else {
                return false;
            }
        }
        return false;
    }

    const showIndeterminate = (data, type, m) => {
        let oldData = JSON.parse(JSON.stringify(valueManagePermission))
        let sumFalse = 0
        let sumTrue = 0
        if (Object.keys(oldData).length > 0) {
            for (let index = 0; index <= Object.keys(oldData[data]).length - 1; index++) {
                if (type === "all") {
                    for (let id = 0; id <= Object.keys(oldData[data][Object.keys(oldData[data])[index]]).length - 1; id++) {
                        if (oldData[data][Object.keys(oldData[data])[index]][Object.keys(oldData[data][Object.keys(oldData[data])[index]])[id]] === false) {
                            sumFalse++
                        } else if (oldData[data][Object.keys(oldData[data])[index]][Object.keys(oldData[data][Object.keys(oldData[data])[index]])[id]] === true) {
                            sumTrue++
                        }
                    }
                } else {
                    if (oldData[data][Object.keys(oldData[data])[index]][type] === false) {
                        sumFalse++
                    } else if (oldData[data][Object.keys(oldData[data])[index]][type] === true) {
                        sumTrue++
                    }
                }
            }
            if (sumTrue > 0 && sumFalse > 0) {
                return true;
            } else {
                return false;
            }
        }
        return false;
    }
    
    return (
        <>
            <Helmet>
                <title>HOME | PMS </title>
            </Helmet>
            <Box
                sx={{
                    backgroundColor: 'background.default',
                    minHeight: '100%',
                    py: 3
                }}
            >
                <Container maxWidth="xl">
                    <Grid container pt={2} pb={2}>
                        <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.link} onClick={() => clickLink('/admin/security')}>{t('security.security')}</span> / <span style={styles.end} >{t('security.createRolePermission')}</span></Typography>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} >
                            <Typography variant="h1" fontSize={36} lineHeight="53.82px" fontWeight="500" color="#404349">
                                {t('security.createRolePermission')}
                            </Typography>
                        </Grid>
                        <Grid direction="column"
                            container item
                            justifyContent="center"
                            alignItems="center">
                            <Grid container item>
                                <Paper elevation={6} sx={{ 'border-radius': '20px', width: '100%', ".MuiFormHelperText-root": { color: " #CC6058 !important", fontSize: "14px", lineHeight: "24px", }, ".MuiOutlinedInput-root": { padding: "8.5px 14px", ".MuiInputBase-input": { padding: "0" } } }} >
                                    <Box sx={{ padding: "30px 47px 20px 30px" }}>
                                        <Typography color="#404349" fontWeight="500" pb="20px" fontSize={24} lineHeight="26.4px" display="flex">{t('security.role')}</Typography>
                                        <Divider />
                                    </Box>
                                    <Box display="flex" sx={{ padding: "0 47px 20px 30px" }}>
                                        <Box width="50%" pr="40px" classes={{ root: classes.input }} sx={{ paddingTop: "0 !important", ".MuiFormControl-root": { marginTop: "7px" }, }}>
                                            <Typography color="#404349" fontWeight="500" fontSize={18} lineHeight="24px" display="flex">{t('admin.inputForm.code')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                            <TextField
                                                error={Boolean(formik.touched.code && formik.errors.code) === false ? checkCode === true ? true : false : true}
                                                fullWidth
                                                helperText={formik.touched.code && formik.errors.code}
                                                margin="normal"
                                                name="code"
                                                onBlur={formik.handleBlur}
                                                onChange={formik.handleChange}
                                                type="text"
                                                value={formik.values.code}
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                sx={{ maxWidth: "610px", ".MuiOutlinedInput-root": { color: "#404349", } }}
                                                // sx={{ maxWidth: "610px", ".MuiOutlinedInput-root": { color: "#404349", "&:hover": { ".MuiOutlinedInput-notchedOutline": { borderColor: "#5DA196" } } } }}
                                                placeholder={t('admin.inputForm.placeholder.codeRole')}
                                            />
                                            {Boolean(formik.touched.code && formik.errors.code) === false && checkCode === true ? (<FormHelperText error sx={{ marginTop: "-5px", marginRight: "14px", marginBottom: "8px", marginLeft: "14px" }}>{t('label.alreadyUsed')} </FormHelperText>) : <></>}
                                        </Box>
                                        <Box width="50%" sx={{ paddingTop: "0 !important" }}>
                                            <Typography color="#404349" fontSize={18} fontWeight="500" lineHeight="24px" display="flex">{t('admin.inputForm.status')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                            <Box sx={{ marginTop: "7px", height: "100%", "max-height": "40px", display: "flex", "align-items": "center" }}>
                                                <FormGroup >
                                                    <FormControlLabel
                                                        sx={{ m: 0, ".MuiTypography-root": { color: "#404349" } }}
                                                        control={<IOSSwitch checked={status} onChange={() => handleStatus()} />}
                                                        label={status ? t('admin.inputForm.active') : t('admin.inputForm.inActive')}
                                                    // disabled
                                                    />
                                                </FormGroup>
                                                {/* <Typography color="#404349" fontSize={18} lineHeight="24px" display="flex">{status ? t('admin.inputForm.active') : t('admin.inputForm.inActive')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography> */}
                                            </Box>
                                        </Box>
                                    </Box>
                                    <Box sx={{ padding: "0px 47px 30px 30px" }}>
                                        <Box sx={{ paddingTop: "0 !important", ".MuiFormControl-root": { marginTop: "7px" }, ".MuiFormHelperText-root": { color: " #CC6058 !important", fontSize: "14px", lineHeight: "24px", }, ".MuiOutlinedInput-root": { padding: "8.5px 14px", ".MuiInputBase-input": { padding: "0" } } }}>
                                            <Typography color="#404349" fontSize={18} fontWeight="500" lineHeight="24px" display="flex">{t('admin.inputForm.name')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                            <TextField
                                                error={Boolean(formik.touched.name && formik.errors.name)}
                                                fullWidth
                                                // helperText={formik.touched.name && formik.errors.name}
                                                margin="normal"
                                                name="name"
                                                onBlur={formik.handleBlur}
                                                onChange={formik.handleChange}
                                                type="text"
                                                value={formik.values.name}
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                sx={{ ".MuiOutlinedInput-root": { color: "#404349", } }}
                                                // sx={{ ".MuiOutlinedInput-root": { color: "#404349", "&:hover": { ".MuiOutlinedInput-notchedOutline": { borderColor: "#5DA196" } } } }}
                                                placeholder={t('admin.inputForm.placeholder.nameRole')}

                                            />
                                            <Typography fontSize={14} color={Boolean(formik.touched.name && formik.errors.name) && formik.values.name !== "" ? "#CC6058" : "#AAAAAA"} fontWeight="300" lineHeight="24px" display="flex">{t('security.max80Characters')}</Typography>
                                            {Boolean(formik.touched.name && formik.errors.name) && formik.values.name === "" ? <FormHelperText error sx={{ marginTop: "7px", marginRight: "14px", marginBottom: "0px", marginLeft: "14px" }}>{formik.errors.name}</FormHelperText> : <></>}
                                        </Box>
                                        <Box sx={{ paddingTop: "20px !important", ".MuiFormControl-root": { marginTop: "7px" }, ".MuiFormHelperText-root": { color: " #CC6058 !important", fontSize: "14px", lineHeight: "24px", }, ".MuiOutlinedInput-root": { padding: "8.5px 14px", ".MuiInputBase-input": { padding: "0" } } }}>
                                            <Typography color="#404349" fontSize={18} fontWeight="500" lineHeight="24px" display="flex">{t('admin.inputForm.description')}</Typography>
                                            <TextField
                                                error={Boolean(formik.touched.description && formik.errors.description)}
                                                fullWidth
                                                // helperText={touched.nameTH && errors.nameTH}
                                                margin="normal"
                                                name="description"
                                                onBlur={formik.handleBlur}
                                                onChange={formik.handleChange}
                                                type="text"
                                                value={formik.values.description}
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                sx={{ ".MuiOutlinedInput-root": { height: "63px", "align-items": "flex-start", color: "#404349", } }}
                                                // sx={{ ".MuiOutlinedInput-root": { height: "63px", "align-items": "flex-start", color: "#404349", "&:hover": { ".MuiOutlinedInput-notchedOutline": { borderColor: "#5DA196" } } } }}
                                                placeholder={t('admin.inputForm.placeholder.descriptionRole')}
                                                multiline={true}
                                                maxRows={2}
                                            />
                                            <Typography fontSize={14} color={Boolean(formik.touched.description && formik.errors.description) && formik.values.description !== "" ? "#CC6058" : "#AAA"} fontWeight="300" lineHeight="24px" display="flex">{t('security.max180Characters')}</Typography>
                                        </Box>
                                        <Box sx={{ paddingTop: "20px !important", ".MuiOutlinedInput-root": { padding: "8.5px 14px", ".MuiInputBase-input": { padding: "0" } } }}>
                                            <Typography color="#404349" fontSize={18} fontWeight="500" lineHeight="24px" display="flex" pb="13px" >{t('security.roleType')} <span style={{ paddingLeft: "15px", color: "#939393", fontSize: "13px", fontWeight: "300", lineHeight: "24px" }}>{t('security.ifCreatedSuccessfully')}</span></Typography>
                                            <Box sx={{ display: "flex", alignItems: "center" }} >
                                                <Radio sx={{ padding: "0" }} name="radio" value="1" checked={roleType === "manual"} size="small" onClick={e => setRoleType("manual")} />
                                                <Typography pl="10px" fontSize={16} lineHeight="23.92px" color="#404349">{t('security.manual')}</Typography>
                                            </Box>
                                            <Typography fontSize={14} pl="30px" pt="2px" lineHeight="21px" fontWeight="300" color="#AAAAAA" pb="10px">{t('security.addTheRole')}</Typography>
                                            <Box sx={{ display: "flex", alignItems: "center" }} >
                                                <Radio sx={{ padding: "0" }} name="radio" value="1" checked={roleType === "auto"} size="small" onClick={e => setRoleType("auto")} />
                                                <Typography pl="10px" fontSize={16} lineHeight="23.92px" color="#404349">{t('security.autoTargetGroup')}</Typography>
                                            </Box>
                                            <Typography fontSize={14} pl="30px" pt="2px" lineHeight="21px" fontWeight="300" color="#AAAAAA" >{t('security.automaticallyAdd')}</Typography>
                                            <Collapse in={roleType === "auto"}>
                                                <Box pt="7px">
                                                    <Select
                                                        id="workload-select"
                                                        inputlabelprops={{ shrink: false }}
                                                        variant="outlined"
                                                        size="small"
                                                        error={Boolean(formik.touched.auto_target_group && formik.errors.auto_target_group)}
                                                        fullWidth
                                                        name="auto_target_group"
                                                        defaultValue=""
                                                        displayEmpty
                                                        className="white-bg"
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.auto_target_group}
                                                        onChange={formik.handleChange}
                                                        getOptionLabel={(option) => option?.name}
                                                    >
                                                        <MenuItem disabled value="" sx={{ display: "none" }}>
                                                            <Typography variant="sub_label" style={{ fontWeight: "300" }}>{t('security.selectTargetGroup')} </Typography>
                                                        </MenuItem>
                                                        {
                                                            targetGroup?.length > 0 ?
                                                                targetGroup.map(item => {
                                                                    return (
                                                                        <MenuItem value={item.serial} key={item.serial}>
                                                                            <span style={{ overflow: "hidden", textOverflow: "ellipsis", color: "#404349", fontSize: "16px", fontWeight: "400", lineHeight: "21px" }}>{item?.name} {Util.formatData(item?.description, false) !== false ? "- " + item?.description : ""}</span>
                                                                        </MenuItem>
                                                                    )
                                                                })

                                                                : <MenuItem value="">
                                                                    ---{t('label.notFund')}---
                                                                </MenuItem>
                                                        }
                                                    </Select>
                                                    {formik.touched.auto_target_group && formik.errors.auto_target_group ? (<FormHelperText error sx={{ marginTop: "3px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{formik.errors.auto_target_group} </FormHelperText>) : <></>}
                                                </Box>
                                            </Collapse>

                                        </Box>
                                    </Box>
                                </Paper>
                                <Paper elevation={6} sx={{ marginTop: "35px", 'border-radius': '20px', width: '100%', ".MuiFormHelperText-root": { color: " #CC6058 !important", fontSize: "14px", lineHeight: "24px", }, ".MuiOutlinedInput-root": { padding: "8.5px 14px", ".MuiInputBase-input": { padding: "0" } } }} >
                                    <Box sx={{ padding: "30px 30px 20px 30px" }}>
                                        <Typography color="#404349" fontWeight="500" pb="20px" fontSize={24} lineHeight="26.4px" display="flex">{t('security.permission')}</Typography>
                                        <Divider />
                                    </Box>
                                    <Box sx={{ padding: "0 41px", ".MuiOutlinedInput-root": { color: "#404349", } }}>
                                        {/* <Box sx={{ padding: "0 41px", ".MuiOutlinedInput-root": { color: "#404349", "&:hover": { ".MuiOutlinedInput-notchedOutline": { borderColor: "#5DA196" } } },".MuiOutlinedInput-root.Mui-error": { "&:hover": { ".MuiOutlinedInput-notchedOutline": { borderColor: "#CC6058" } } } }}> */}
                                        <Typography color="#404349" fontWeight="500" fontSize={18} lineHeight="24px" pb="7px" display="flex">{t('security.permissionGroup')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                        <Select
                                            id="workload-select"
                                            inputlabelprops={{ shrink: false }}
                                            variant="outlined"
                                            size="small"
                                            error={Boolean(formik.touched.permission_group && formik.errors.permission_group)}
                                            fullWidth
                                            helperText={formik.touched.permission_group && formik.errors.permission_group}
                                            name="permission_group"
                                            defaultValue=""
                                            displayEmpty
                                            className="white-bg"
                                            onBlur={formik.handleBlur}
                                            value={formik.values.permission_group}
                                            onChange={formik.handleChange}
                                            getOptionLabel={(option) => option?.name}
                                        >
                                            <MenuItem disabled value="" sx={{ display: "none" }}>
                                                <Typography variant="sub_label" style={{ fontWeight: "300" }}>{t('security.selectPermissionGroup')} </Typography>
                                            </MenuItem>
                                            {
                                                permissionGroup?.length > 0 ?
                                                    permissionGroup.map(item => {
                                                        return (
                                                            <MenuItem value={item.serial} key={item.serial} onClick={e => setValidateTarget(item.serial)}>
                                                                <span style={{ color: "#404349", fontSize: "16px", fontWeight: "400", lineHeight: "21px" }}>{item.name}</span>
                                                            </MenuItem>
                                                        )
                                                    })

                                                    : <MenuItem value="">
                                                        ---{t('label.notFund')}---
                                                    </MenuItem>
                                            }
                                        </Select>
                                        {formik.touched.permission_group && formik.errors.permission_group ? (<FormHelperText error sx={{ marginTop: "3px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{formik.errors.permission_group} </FormHelperText>) : <></>}
                                        <Collapse in={permissionGroup.filter(rs => rs?.serial === formik.values.permission_group).length > 0 && permissionGroup.filter(rs => rs?.serial === formik.values.permission_group)[0].code === "target_group"}>
                                            <Typography color="#404349" fontWeight="500" fontSize={18} lineHeight="24px" pb="7px" pt="12px" display="flex" sx={{ textTransform: "capitalize" }} >{t('security.selectTargetGroup')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                            <Box >
                                                <Select
                                                    id="workload-select"
                                                    inputlabelprops={{ shrink: false }}
                                                    variant="outlined"
                                                    size="small"
                                                    error={Boolean(formik.touched.target_group && formik.errors.target_group)}
                                                    fullWidth
                                                    name="target_group"
                                                    defaultValue=""
                                                    displayEmpty
                                                    className="white-bg"
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.target_group}
                                                    onChange={formik.handleChange}
                                                    getOptionLabel={(option) => option?.name}
                                                >
                                                    <MenuItem disabled value="" sx={{ display: "none" }}>
                                                        <Typography variant="sub_label" style={{ fontWeight: "300" }}>{t('security.selectTargetGroup')} </Typography>
                                                    </MenuItem>
                                                    {
                                                        targetGroup?.length > 0 ?
                                                            targetGroup.map(item => {
                                                                return (
                                                                    <MenuItem value={item.serial} key={item.serial} >
                                                                        <span style={{ overflow: "hidden", textOverflow: "ellipsis", color: "#404349", fontSize: "16px", fontWeight: "400", lineHeight: "21px" }}>{item?.name} {Util.formatData(item?.description, false) !== false ? "- " + item?.description : ""}</span>
                                                                    </MenuItem>
                                                                )
                                                            })

                                                            : <MenuItem value="">
                                                                ---{t('label.notFund')}---
                                                            </MenuItem>
                                                    }
                                                </Select>
                                                {formik.touched.target_group && formik.errors.target_group ? (<FormHelperText error sx={{ marginTop: "3px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{formik.errors.target_group} </FormHelperText>) : <></>}
                                            </Box>
                                        </Collapse>
                                        <Box mt="21px" pt="18px" pl="30px" pr="28px" sx={{ border: "1px solid #CED4DA", borderRadius: "4px" }}>
                                            <Box pb="24px" display="flex" alignItems="center" justifyContent="space-between">
                                                <Typography color="#404349" fontWeight="500" fontSize={24} lineHeight="26.4px" display="flex">{t('security.managePermission')}</Typography>
                                                <Typography sx={{ cursor: "pointer" }} color="#AAAAAA" fontWeight="300" fontSize={16} lineHeight="24px" onClick={expandAll} display="flex">{showExpandAll() ? t('label.collapseAll') : t('label.expandAll')}</Typography>
                                            </Box>
                                            <Box sx={{ background: "#FAFAFA", height: "50px" }} px="18px" display="flex" alignItems="center">
                                                <Box width="calc(100% - 650px)">
                                                    <Typography color="#A0A0A0" fontWeight="400" fontSize={14} lineHeight="21px" display="flex">{t('label.feature')}</Typography>
                                                </Box>
                                                <Box display="flex" width="650px" justifyContent="flex-end">
                                                    <Box sx={{ minWidth: "27px", }} mr="45px">
                                                        <Typography color="#A0A0A0" fontWeight="400" fontSize={14} lineHeight="21px" display="flex">{t('label.all')}</Typography>
                                                    </Box>
                                                    {/* <Box sx={{ minWidth: "27px", }} mr="45px">
                                                        <Typography color="#A0A0A0" fontWeight="400" fontSize={14} lineHeight="21px" display="flex">{t('label.enable')}</Typography>
                                                    </Box> */}
                                                    <Box sx={{ minWidth: "27px", }} mr="45px">
                                                        <Typography color="#A0A0A0" fontWeight="400" fontSize={14} lineHeight="21px" display="flex">{t('label.view')}</Typography>
                                                    </Box>
                                                    <Box sx={{ minWidth: "27px", }} mr="45px">
                                                        <Typography color="#A0A0A0" fontWeight="400" fontSize={14} lineHeight="21px" display="flex">{t('label.create')}</Typography>
                                                    </Box>
                                                    <Box sx={{ minWidth: "27px", }} mr="45px">
                                                        <Typography color="#A0A0A0" fontWeight="400" fontSize={14} lineHeight="21px" display="flex">{t('label.edit')}</Typography>
                                                    </Box>
                                                    <Box sx={{ minWidth: "27px", }} mr="45px">
                                                        <Typography color="#A0A0A0" fontWeight="400" fontSize={14} lineHeight="21px" display="flex">{t('label.delete')}</Typography>
                                                    </Box>
                                                    <Box sx={{ minWidth: "27px", }} mr="45px">
                                                        <Typography color="#A0A0A0" fontWeight="400" fontSize={14} lineHeight="21px" display="flex">{t('label.import')}</Typography>
                                                    </Box>
                                                    <Box sx={{ minWidth: "27px", }} >
                                                        <Typography color="#A0A0A0" fontWeight="400" fontSize={14} lineHeight="21px" display="flex">{t('label.export')}</Typography>
                                                    </Box>
                                                </Box>
                                            </Box>
                                            <Divider />
                                            <Box height="408px" sx={{ overflowY: "overlay" }}>
                                                {
                                                    Util.formatData(dataManagePermission, false) !== false && dataManagePermission.length > 0 ? dataManagePermission.map((item, index) =>
                                                        <Box>
                                                            {index !== 0 ?
                                                                <Divider />
                                                                : null}
                                                            <Box sx={{ height: "50px" }} px="18px" display="flex" alignItems="center">
                                                                <Box width="calc(100% - 650px)" display="flex">
                                                                    <Box width="54px" display="flex">
                                                                        {Object.keys(valueManagePermission).length > 0 ? showMoreTable[item?.serial] === true ? <ShowLess onClick={e => changeShowMoreTable(item?.serial)} style={{ cursor: "pointer" }} /> : <ShowMore onClick={e => changeShowMoreTable(item?.serial)} style={{ cursor: "pointer" }} /> : null}
                                                                    </Box>
                                                                    <Box width="calc(100% - 54px)" display="flex">
                                                                        <Typography color="#404349" fontWeight="500" fontSize={18} lineHeight="26.91px" sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{item?.group}</Typography>
                                                                    </Box>
                                                                </Box>
                                                                <Box display="flex" width="650px" justifyContent="flex-end">
                                                                    <Box sx={{ minWidth: "27px", display: "flex", flexDirection: "column", justifyContent: "center" }} mr="45px">
                                                                        <Typography sx={{ height: "0", overflow: "hidden" }} color="#A0A0A0" fontWeight="400" fontSize={14} lineHeight="21px">{t('label.all')}</Typography>
                                                                        {/* {showCheckBox(item, "all") ? */}
                                                                        <Checkbox color="primary" onClick={e => checkAll(item?.serial, "all")} checked={showCheckAll(item?.serial, "all")} indeterminate={showIndeterminate(item?.serial, "all")} sx={{ p: 0, ".MuiSvgIcon-root": { width: "26.7px", height: "26.7px" } }} />
                                                                        {/* : null} */}
                                                                    </Box>
                                                                    {/* <Box sx={{ minWidth: "27px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }} mr="45px">
                                                                        <Typography sx={{ height: "0", overflow: "hidden" }} color="#A0A0A0" fontWeight="400" fontSize={14} lineHeight="21px">{t('label.enable')}</Typography>
                                                                        {showCheckBox(item, "enable") ?
                                                                            <Checkbox color="primary" onClick={e => checkAll(item?.serial, "enable")} checked={showCheckAll(item?.serial, "enable")} sx={{ p: 0, ".MuiSvgIcon-root": { width: "26.7px", height: "26.7px" } }} />
                                                                            : null}
                                                                    </Box> */}
                                                                    <Box sx={{ minWidth: "27px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }} mr="45px">
                                                                        <Typography sx={{ height: "0", overflow: "hidden" }} color="#A0A0A0" fontWeight="400" fontSize={14} lineHeight="21px">{t('label.view')}</Typography>
                                                                        {showCheckBox(item, "view") ?
                                                                            <Checkbox color="primary" onClick={e => checkAll(item?.serial, "view")} checked={showCheckAll(item?.serial, "view")} indeterminate={showIndeterminate(item?.serial, "view")} sx={{ p: 0, ".MuiSvgIcon-root": { width: "26.7px", height: "26.7px" } }} />
                                                                            : null}
                                                                    </Box>
                                                                    <Box sx={{ minWidth: "27px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }} mr="45px">
                                                                        <Typography sx={{ height: "0", overflow: "hidden" }} color="#A0A0A0" fontWeight="400" fontSize={14} lineHeight="21px">{t('label.create')}</Typography>
                                                                        {showCheckBox(item, "create") ?
                                                                            <Checkbox color="primary" onClick={e => checkAll(item?.serial, "create")} checked={showCheckAll(item?.serial, "create")} indeterminate={showIndeterminate(item?.serial, "create")} sx={{ p: 0, ".MuiSvgIcon-root": { width: "26.7px", height: "26.7px" } }} />
                                                                            : null}
                                                                    </Box>
                                                                    <Box sx={{ minWidth: "27px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }} mr="45px">
                                                                        <Typography sx={{ height: "0", overflow: "hidden" }} color="#A0A0A0" fontWeight="400" fontSize={14} lineHeight="21px">{t('label.edit')}</Typography>
                                                                        {showCheckBox(item, "edit") ?
                                                                            <Checkbox color="primary" onClick={e => checkAll(item?.serial, "edit")} checked={showCheckAll(item?.serial, "edit")} indeterminate={showIndeterminate(item?.serial, "edit")} sx={{ p: 0, ".MuiSvgIcon-root": { width: "26.7px", height: "26.7px" } }} />
                                                                            : null}
                                                                    </Box>
                                                                    <Box sx={{ minWidth: "27px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }} mr="45px">
                                                                        <Typography sx={{ height: "0", overflow: "hidden" }} color="#A0A0A0" fontWeight="400" fontSize={14} lineHeight="21px">{t('label.delete')}</Typography>
                                                                        {showCheckBox(item, "delete") ?
                                                                            <Checkbox color="primary" onClick={e => checkAll(item?.serial, "delete")} checked={showCheckAll(item?.serial, "delete")} indeterminate={showIndeterminate(item?.serial, "delete")} sx={{ p: 0, ".MuiSvgIcon-root": { width: "26.7px", height: "26.7px" } }} />
                                                                            : null}
                                                                    </Box>
                                                                    <Box sx={{ minWidth: "27px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }} mr="45px">
                                                                        <Typography sx={{ height: "0", overflow: "hidden" }} color="#A0A0A0" fontWeight="400" fontSize={14} lineHeight="21px">{t('label.import')}</Typography>
                                                                        {showCheckBox(item, "import") ?
                                                                            <Checkbox color="primary" onClick={e => checkAll(item?.serial, "import")} checked={showCheckAll(item?.serial, "import")} indeterminate={showIndeterminate(item?.serial, "import")} sx={{ p: 0, ".MuiSvgIcon-root": { width: "26.7px", height: "26.7px" } }} />
                                                                            : null}
                                                                    </Box>
                                                                    <Box sx={{ minWidth: "27px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }} >
                                                                        <Typography sx={{ height: "0", overflow: "hidden" }} color="#A0A0A0" fontWeight="400" fontSize={14} lineHeight="21px">{t('label.export')}</Typography>
                                                                        {showCheckBox(item, "export") ?
                                                                            <Checkbox color="primary" onClick={e => checkAll(item?.serial, "export")} checked={showCheckAll(item?.serial, "export")} indeterminate={showIndeterminate(item?.serial, "export")} sx={{ p: 0, ".MuiSvgIcon-root": { width: "26.7px", height: "26.7px" } }} />
                                                                            : null}
                                                                    </Box>
                                                                </Box>
                                                            </Box>
                                                            <Collapse in={Object.keys(valueManagePermission).length > 0 ? showMoreTable[item?.serial] : false}>
                                                                {
                                                                    Util.formatData(item.permissions, false) !== false && item.permissions.length > 0 ? item.permissions.map(items =>
                                                                        <Box>
                                                                            <Divider />
                                                                            <Box sx={{ height: "50px" }} px="18px" display="flex" alignItems="center">
                                                                                <Box width="calc(100% - 650px)" display="flex">
                                                                                    <Box width="54px" display="flex">
                                                                                    </Box>
                                                                                    <Box width="calc(100% - 54px)" display="flex">
                                                                                        <Typography color="#404349" fontWeight="400" fontSize={18} lineHeight="26.91px" sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{items?.name}</Typography>
                                                                                    </Box>
                                                                                </Box>
                                                                                <Box display="flex" width="650px" justifyContent="flex-end">
                                                                                    <Box sx={{ minWidth: "27px", display: "flex", flexDirection: "column", justifyContent: "center" }} mr="45px">
                                                                                        <Typography sx={{ height: "0", overflow: "hidden" }} color="#A0A0A0" fontWeight="400" fontSize={14} lineHeight="21px">{t('label.all')}</Typography>
                                                                                        {items?.all?.have === true && Object.keys(valueManagePermission).length > 0 ?
                                                                                            <Checkbox color="primary" onClick={e => checkOne(item?.serial, items?.serial, "export")} checked={valueManagePermission[item?.serial][items?.serial]?.all} sx={{ p: 0, ".MuiSvgIcon-root": { width: "26.7px", height: "26.7px" } }} />
                                                                                            : null}
                                                                                    </Box>
                                                                                    {/* <Box sx={{ minWidth: "27px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }} mr="45px">
                                                                                        <Typography sx={{ height: "0", overflow: "hidden" }} color="#A0A0A0" fontWeight="400" fontSize={14} lineHeight="21px">{t('label.enable')}</Typography>
                                                                                        {items?.enable?.have === true && Object.keys(valueManagePermission).length > 0 ?
                                                                                            <Checkbox color="primary" onClick={e => checkOne(item?.serial, items?.serial, "enable")} checked={valueManagePermission[item?.serial][items?.serial]?.enable} sx={{ p: 0, ".MuiSvgIcon-root": { width: "26.7px", height: "26.7px" } }} />
                                                                                            : null}
                                                                                    </Box> */}
                                                                                    <Box sx={{ minWidth: "27px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }} mr="45px">
                                                                                        <Typography sx={{ height: "0", overflow: "hidden" }} color="#A0A0A0" fontWeight="400" fontSize={14} lineHeight="21px">{t('label.view')}</Typography>
                                                                                        {items?.view?.have === true && Object.keys(valueManagePermission).length > 0 ?
                                                                                            <Checkbox color="primary" onClick={e => checkOne(item?.serial, items?.serial, "view")} checked={valueManagePermission[item?.serial][items?.serial]?.view} sx={{ p: 0, ".MuiSvgIcon-root": { width: "26.7px", height: "26.7px" } }} />
                                                                                            : null}

                                                                                        {Object.keys(valueManagePermission).length > 0 ? valueManagePermission[item?.serial][items?.serial]?.view : null}
                                                                                    </Box>
                                                                                    <Box sx={{ minWidth: "27px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }} mr="45px">
                                                                                        <Typography sx={{ height: "0", overflow: "hidden" }} color="#A0A0A0" fontWeight="400" fontSize={14} lineHeight="21px">{t('label.create')}</Typography>
                                                                                        {items?.create?.have === true && Object.keys(valueManagePermission).length > 0 ?
                                                                                            <Checkbox color="primary" onClick={e => checkOne(item?.serial, items?.serial, "create")} checked={valueManagePermission[item?.serial][items?.serial]?.create} sx={{ p: 0, ".MuiSvgIcon-root": { width: "26.7px", height: "26.7px" } }} />
                                                                                            : null}
                                                                                    </Box>
                                                                                    <Box sx={{ minWidth: "27px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }} mr="45px">
                                                                                        <Typography sx={{ height: "0", overflow: "hidden" }} color="#A0A0A0" fontWeight="400" fontSize={14} lineHeight="21px">{t('label.edit')}</Typography>
                                                                                        {items?.edit?.have === true && Object.keys(valueManagePermission).length > 0 ?
                                                                                            <Checkbox color="primary" onClick={e => checkOne(item?.serial, items?.serial, "edit")} checked={valueManagePermission[item?.serial][items?.serial]?.edit} sx={{ p: 0, ".MuiSvgIcon-root": { width: "26.7px", height: "26.7px" } }} />
                                                                                            : null}
                                                                                    </Box>
                                                                                    <Box sx={{ minWidth: "27px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }} mr="45px">
                                                                                        <Typography sx={{ height: "0", overflow: "hidden" }} color="#A0A0A0" fontWeight="400" fontSize={14} lineHeight="21px">{t('label.delete')}</Typography>
                                                                                        {items?.delete?.have === true && Object.keys(valueManagePermission).length > 0 ?
                                                                                            <Checkbox color="primary" onClick={e => checkOne(item?.serial, items?.serial, "delete")} checked={valueManagePermission[item?.serial][items?.serial]?.delete} sx={{ p: 0, ".MuiSvgIcon-root": { width: "26.7px", height: "26.7px" } }} />
                                                                                            : null}
                                                                                    </Box>
                                                                                    <Box sx={{ minWidth: "27px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }} mr="45px">
                                                                                        <Typography sx={{ height: "0", overflow: "hidden" }} color="#A0A0A0" fontWeight="400" fontSize={14} lineHeight="21px">{t('label.import')}</Typography>
                                                                                        {items?.import?.have === true && Object.keys(valueManagePermission).length > 0 ?
                                                                                            <Checkbox color="primary" onClick={e => checkOne(item?.serial, items?.serial, "import")} checked={valueManagePermission[item?.serial][items?.serial]?.import} sx={{ p: 0, ".MuiSvgIcon-root": { width: "26.7px", height: "26.7px" } }} />
                                                                                            : null}
                                                                                    </Box>
                                                                                    <Box sx={{ minWidth: "27px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }} >
                                                                                        <Typography sx={{ height: "0", overflow: "hidden" }} color="#A0A0A0" fontWeight="400" fontSize={14} lineHeight="21px">{t('label.export')}</Typography>
                                                                                        {items?.export?.have === true && Object.keys(valueManagePermission).length > 0 ?
                                                                                            <Checkbox color="primary" onClick={e => checkOne(item?.serial, items?.serial, "export")} checked={valueManagePermission[item?.serial][items?.serial]?.export} sx={{ p: 0, ".MuiSvgIcon-root": { width: "26.7px", height: "26.7px" } }} />
                                                                                            : null}
                                                                                    </Box>
                                                                                </Box>
                                                                            </Box>
                                                                        </Box>
                                                                    )
                                                                        : null
                                                                }
                                                            </Collapse>
                                                        </Box>
                                                    )
                                                        :
                                                        null
                                                }
                                            </Box>
                                        </Box>
                                    </Box>
                                    <Grid container mt="30px" mb="48px" pr="41px" >
                                        <Grid item xs display="flex" flexDirection="row-reverse">
                                            <Box sx={{ width: "100px" }}>
                                                <Button onClick={formik.submitForm} color="primary" variant="contained" fullWidth sx={{ textTransform: "none" }}>
                                                    {t('label.create')}
                                                </Button>
                                            </Box>
                                            <Box mr={2} sx={{ width: "100px" }}>
                                                <Button color="black" variant="outlined" fullWidth onClick={handleCancel} sx={{ textTransform: "none" }}>
                                                    {t('label.cancel')}
                                                </Button>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>
                        </Grid>
                    </Grid>
                    <SimpleDialog
                        open={isSuccessAddDialogOpen}
                        doDirect={() => handleDirect()}
                        setValue={openSuccessAddDialog}
                        text={t(`security.createdSuccess`)}
                        page={true}
                    />
                    <MessageDialog
                        open={openFailedMessageDialog}
                        setValue={handleCloseFailedMessageDialog}
                        type="fail"
                        title={t(`dialog.label.fail`)}
                        text={errorText + t(`dialog.label.tryAgain`)}
                    />
                    <ConfirmDialog open={discardDialog} warning={true} doConfirm={() => handleDiscardChangeConfirm()} setValue={() => handleDiscardDialog(false)} title={t("achievement.label.dialog.discardTitle")} text={t("achievement.label.dialog.discardText")} />
                </Container>
            </Box>
        </>
    )
};
export default CreateRolePermission;
